var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgX(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "45px",
    height: "45px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fefffe",
    d: "M 7.5,7.5 C 10.8984,7.17964 14.2317,7.51298 17.5,8.5C 19.473,11.6397 21.6397,14.6397 24,17.5C 26.5,14.3333 29,11.1667 31.5,8C 32.9437,7.21948 34.277,7.38615 35.5,8.5C 32.2847,12.4268 28.9513,16.2602 25.5,20C 29.0426,25.586 32.7093,31.086 36.5,36.5C 33.1667,37.8333 29.8333,37.8333 26.5,36.5C 24.5179,33.1897 22.1846,30.1897 19.5,27.5C 16.6454,30.5202 13.9787,33.6868 11.5,37C 10.0563,37.7805 8.72296,37.6139 7.5,36.5C 10.9584,32.4068 14.2917,28.2401 17.5,24C 13.9298,18.607 10.5964,13.107 7.5,7.5 Z M 12.5,9.5 C 13.4959,9.41423 14.3292,9.74756 15,10.5C 20.0869,18.3412 25.4202,26.0079 31,33.5C 31.6877,34.3317 31.521,34.9984 30.5,35.5C 23.9997,27.1612 17.9997,18.4946 12.5,9.5 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.8bc8bc56.svg";
export { ForwardRef as ReactComponent };